import { Icon } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import React from 'react';
import messages from './PolicyDocumentError.messages';
import styles from './PolicyDocumentError.module.scss';

export default function PolicyDocumentError() {
    const translator = useTranslator();
    return (
        <div>
            <Icon icon="mi-warning" className={styles.exclamationIcon} />
            <span>{translator(messages.unableToAccessDocument)}</span>
        </div>
    );
}
